import Cookies from 'js-cookie';
import { onDoSendNotificationToken, onDoRequestHome, onDoRequestKycStatus } from '@/redux/auth';
import { onDoRequestTrading, onDoRequestProfile } from '@/redux/profile';
import { onDoRequestListCta } from '@/redux/notification';
import { TokenManager } from './TokenManager';

const RETRY_INTERVAL = 1000;
const RETRY_TIMEOUT = 5000; // 5 seconds

const dispatchHomeRequests = (dispatch) => {
  dispatch(onDoRequestHome());
  dispatch(onDoRequestKycStatus());
  dispatch(onDoRequestTrading());
  dispatch(onDoRequestProfile());
  dispatch(onDoRequestListCta());
};

const sendNotificationTokenIfAny = (dispatch) => {
  const fcmToken = Cookies.get('notification_token');
  if (fcmToken) {
    dispatch(onDoSendNotificationToken({ fcm_token: fcmToken }));
  }
};

const hasAccessToken = () => Boolean(TokenManager.getAccessToken());

export const HomePageApiService = {
  callHomePageAPIs: (dispatch) => {
    if (!hasAccessToken()) return false;

    try {
      dispatchHomeRequests(dispatch);
      sendNotificationTokenIfAny(dispatch);
      return true;
    } catch (err) {
      return false;
    }
  },

  setupRetryMechanism: (dispatch, pinToken) => {
    // Retry only if we have a pinToken and *no* access token yet
    if (!pinToken || hasAccessToken()) return;

    const retryInterval = setInterval(() => {
      if (hasAccessToken()) {
        clearInterval(retryInterval);
        HomePageApiService.callHomePageAPIs(dispatch);
      }
    }, RETRY_INTERVAL);

    // Safety: stop retrying after timeout
    setTimeout(() => clearInterval(retryInterval), RETRY_TIMEOUT);
  },
};
